import { ChangeItem } from '@app/features/scope-overview/change-request/model'
import { ScopeElementsConfig } from '../../models/scope-elements-config.interface'
import { ValueDiff } from '../../models/entities-with-changes/value-diff.interface'
import { isNil } from 'lodash'
import { EntityWithChanges, EntityChanges } from '../../models/entities-with-changes/entity-with-changes.type'

export function showCrDifferences<T>(config: ScopeElementsConfig, element: EntityWithChanges<T>, fieldName: string) {
  return config?.isChangeRequest && config?.showDiff && isDifferent(element?.changes?.[fieldName])
}

const isDifferent = (value: ValueDiff): boolean => !isNil(value) && value?.new !== value?.old

export function showCrNetDelta(config: ScopeElementsConfig, changeItem: ChangeItem, fieldName: string): boolean {
  const diff = changeItem?.data?.[fieldName]
  return config?.isChangeRequest && config?.showNetDelta && !isNil(diff) && diff.new !== diff.old
}

export function getCrFieldDelta(changeItem: ChangeItem, fieldName: string): number {
  const diff = changeItem?.data?.[fieldName]
  return (diff?.new ?? 0) - (diff?.old ?? 0)
}

export function showPricingDeltaForConfig(config: ScopeElementsConfig): boolean {
  return !!(config?.isChangeRequest && config?.showNetDelta)
}

export function getEntityNetDelta(
  changes: EntityChanges | undefined,
  fieldName: string,
  currentValue: number | null | undefined,
  isAdded: boolean,
  isRemoved: boolean
): number {
  if (isAdded) return currentValue ?? 0
  if (isRemoved) return -(currentValue ?? 0)
  const diff = changes?.[fieldName]
  return diff ? (diff.new ?? 0) - (diff.old ?? 0) : 0
}
